<template lang='pug'>

.page.page_offset_top.page_offset_bottom
  .page-meta
    .container
      .page-meta__inner
        breadcrumbs
        form.search(@submit.prevent="" :class="[{'is-active' : searchActive}, {'is-active' : search !== ''}]")
          label.search__field
            button.search__btn
              i.icon-magnifier
            input(type='text' required @focus="searchActive = !searchActive" @blur="searchActive = !searchActive" placeholder="Поиск" v-model="search").search__input
  .faq-head
    .container
      .faq-head__inner
        h1.faq__title.title.title_size_m Частным лицам
  .accordion
    .container
      .accordion__inner
        aside.accordion__sidebar
          .accordion__item(v-for="item, index in accordion" :class="{'is-active' : showByIndex === index}")
            a(href="#").accordion__title(@click.prevent="toggleItem(index)") {{ item.title }}
            transition(name="slide-toggle"
                      @enter="slideToggleStart"
                      @after-enter="slideToggleEnd"
                      @before-leave="slideToggleStart"
                      @after-leave="slideToggleEnd")
              .accordion__content(v-if="showByIndex === index")
                ul.accordion-menu
                  li.accordion-menu__item(v-for="list, listIndex in item.list" :class="{'is-active' : showByIndexList === listIndex}")
                    a(href="#" @click.prevent="toggleMenuItem(listIndex)").accordion-menu__link {{ list }}
                    transition(name="slide-toggle"
                        @enter="slideToggleStart"
                        @after-enter="slideToggleEnd"
                        @before-leave="slideToggleStart"
                        @after-leave="slideToggleEnd")
                      .accordion-menu__content.page-content(v-if="showByIndexList === listIndex")
                        h2 Какие документы предоставить
                        h3 требования для регистрации для kia rio и kia rio x-line:
                        ul
                          li возраст от 21 года
                          li стаж вождения от 2-х лет
                        p для присоединения к сервису нужно иметь при себе паспорт, водительское удостоверение и банковскую карту.
                        h3 также необходимо прикрепить:
                        ul
                          li фото страницы паспорта с фотографией;
                          li фото страницы паспорта с пропиской;
                          li селфи с паспортом (фото, на котором видно лицо пользователя с открытым документом);
                          li фото водительского удостоверения.
                        h3 требования для регистрации для mercedes-benz cla/gla
                        ul
                          li возраст от 25 лет;
                          li стаж вождения от 5 лет
                        p для присоединения к сервису нужно иметь при себе паспорт, водительское удостоверение и банковскую карту.
                        h3 также необходимо прикрепить фото:
                        ul
                          li фото страницы паспорта с фотографией
                          li фото страницы паспорта с пропиской
                          li селфи с паспортом (фото, на котором видно лицо пользователя с открытым документом)
                          li фото водительского удостоверения

        .accordion-content
          .accordion-content__item(v-for='item, index in accordion' v-if="showByIndex === index")
            .accordion-content__inner.page-content(v-for='list , listIndex in item.list' v-if="showByIndexList === listIndex" )
              h2 Какие документы предоставить {{index + 1}} - {{listIndex + 1}}
              h3 требования для регистрации для kia rio и kia rio x-line:
              ul
                li возраст от 21 года
                li стаж вождения от 2-х лет
              p для присоединения к сервису нужно иметь при себе паспорт, водительское удостоверение и банковскую карту.
              h3 также необходимо прикрепить:
              ul
                li фото страницы паспорта с фотографией;
                li фото страницы паспорта с пропиской;
                li селфи с паспортом (фото, на котором видно лицо пользователя с открытым документом);
                li фото водительского удостоверения.
              h3 требования для регистрации для mercedes-benz cla/gla:
              ul
                li возраст от 25 лет
                li стаж вождения от 5 лет
              p для присоединения к сервису нужно иметь при себе паспорт, водительское удостоверение и банковскую карту.
              h3 также необходимо прикрепить фото:
              ul
                li фото страницы паспорта с фотографией
                li фото страницы паспорта с пропиской
                li селфи с паспортом (фото, на котором видно лицо пользователя с открытым документом)
                li фото водительского удостоверения
</template>

<script>

export default {
  props: [],
  components: {},
  data () {
    return {
      searchActive: false,
      search: '',
      showByIndex: 0,
      showByIndexList: 0,
      accordion: [
        {
          title: 'как присоединиться к сервису',
          list: [
            'Какие документы предоставить',
            'Проверка документов',
            'Нужно ли приезжать в офис или вызывать курьера',
            'Где посмотреть договор'
          ]
        },
        {
          title: 'аренда автомобилей',
          list: [
            'Какие документы предоставить',
            'Проверка документов',
            'Нужно ли приезжать в офис или вызывать курьера',
            'Где посмотреть договор'
          ]
        },
        {
          title: 'заправка автомобилей',
          list: [
            'Какие документы предоставить',
            'Проверка документов',
            'Нужно ли приезжать в офис или вызывать курьера',
            'Где посмотреть договор'
          ]
        },
        {
          title: 'проблемы с арендой',
          list: [
            'Какие документы предоставить',
            'Проверка документов',
            'Нужно ли приезжать в офис или вызывать курьера',
            'Где посмотреть договор'
          ]
        },
        {
          title: 'оплата',
          list: [
            'Какие документы предоставить',
            'Проверка документов',
            'Нужно ли приезжать в офис или вызывать курьера',
            'Где посмотреть договор'
          ]
        },
        {
          title: 'штрафы',
          list: [
            'Какие документы предоставить',
            'Проверка документов',
            'Нужно ли приезжать в офис или вызывать курьера',
            'Где посмотреть договор'
          ]
        },
        {
          title: 'аэропорты',
          list: [
            'Какие документы предоставить',
            'Проверка документов',
            'Нужно ли приезжать в офис или вызывать курьера',
            'Где посмотреть договор'
          ]
        }
      ]
    }
  },
  methods: {
    toggleItem (index) {
      this.showByIndex === index ? this.showByIndex = null : this.showByIndex = index
      this.showByIndexList = 0
    },
    toggleMenuItem (index) {
      this.showByIndexList === index ? this.showByIndexList = null : this.showByIndexList = index
    },
    slideToggleStart (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    slideToggleEnd (el) {
      el.style.height = ''
    }
  },
  computed: {},
  mounted () {
  }
}
</script>

<style lang='sass'>

</style>



// WEBPACK FOOTER //
// src/views/Faq.vue